<template>
  <div>
    <!-- <v-card> -->
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      app
      dark
      color="rgba(1,162,165,1)"
      mini-variant-width="70"
      width="190"
    >
    <v-list two-line>
      <v-list-item >
        <v-avatar size="50" tile class="mr-2">
          <img src="../assets/admin/logo-te.png">
        </v-avatar>
        <v-list-item-content class="py-0">
            <p class="subtitle-1 my-auto">Teacher Edition</p>
          </v-list-item-content>
          
        <v-btn
          icon
          @click.stop="mini = !mini"
        >
          <v-icon size="40">mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      </v-list>
      <v-divider></v-divider>
      
      <v-list dense two-line>
        <v-list-item to="/schoolTeacher" >
          <v-list-item-icon class="mr-4">
            <v-icon size="30">mdi-home</v-icon>
          </v-list-item-icon>
          
          <v-list-item-content>
            <p class="subtitle-1">Dashboard</p>
          </v-list-item-content>
        </v-list-item>
        <!--<v-list-item to="/schoolTeacher/classroom" v-if="hasClassrooms && IsRegister !='true'">-->
          <v-list-item v-if="hasClassrooms === null">
            <v-list-item-icon class="mr-4">
              <!-- Ícono de carga -->
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="subtitle-1 my-auto" >Charging...</p>
            </v-list-item-content>
          </v-list-item>

          <v-list-item to="/schoolTeacher/classroom" v-else-if="hasClassrooms">
            <v-list-item-icon class="mr-4">
              <img src="../assets/admin/teacher-home.svg" style="width: 30px; height: 30px;">
            </v-list-item-icon>
            <v-list-item-content>
              <p class="subtitle-1 my-auto" >Classroom</p>
            </v-list-item-content>
          </v-list-item>

          <v-tooltip color="grey darken-3" right v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-list-item v-bind="attrs" v-on="on">
                <v-list-item-icon class="mr-4">
                  <img src="../assets/admin/teacher-home.svg" style="width: 30px; height: 30px;">
                </v-list-item-icon>
                <v-list-item-content class="">
                  <p class="subtitle-1 my-auto teal--text text--lighten-3" >Classroom</p>
                </v-list-item-content>
              </v-list-item>
            </template>
          <span>
            <p class="mb-0 mt-2">Classroom is only available with the Lee Lee Student Edition purchase.</p>
            <p class="mb-0 mt-2">Available in Classroom: </p>
            <ul>
              <li>Game Progress</li>
              <li>Multiplayer feature</li>
              <li>Progress Checks</li>
              <li>Lee Lee At-Home QR Codes</li>
            </ul>
          </span>
        </v-tooltip>
        
        <v-list-item to="/schoolTeacher/activitieslist">
          <v-list-item-icon class="mr-4">
              <img src="../assets/admin/teaching-tools.svg" style="width: 30px; height: 30px;">
            </v-list-item-icon>

          <v-list-item-content>
            <p class="subtitle-1 my-auto">Teaching Tools</p>
          </v-list-item-content>
        </v-list-item>
        <!--<v-list-item to="/schoolTeacher/statistics" v-if="hasClassrooms && IsRegister !='true'">-->
          <v-list-item v-if="hasClassrooms === null">
            <v-list-item-icon class="mr-4">
              <!-- Ícono de carga -->
              <v-progress-circular
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-list-item-icon>
            <v-list-item-content>
              <p class="subtitle-1 my-auto" >Charging...</p>
            </v-list-item-content>
          </v-list-item>
        <v-list-item to="/schoolTeacher/statistics" v-else-if="hasClassrooms">  
          <v-list-item-icon class="mr-4">
              <v-icon size="30">mdi-align-vertical-bottom</v-icon>
            </v-list-item-icon>

          <v-list-item-content>
            <p class="subtitle-1">Reports</p>
          </v-list-item-content>
        </v-list-item>
        <v-tooltip color="grey darken-3" right v-else>
          <template v-slot:activator="{ on, attrs }">
            <v-list-item v-bind="attrs" v-on="on">
              <v-list-item-icon class="mr-4">
                  <v-icon size="30">mdi-align-vertical-bottom</v-icon>
                </v-list-item-icon>

              <v-list-item-content>
                <p class="subtitle-1 teal--text text--lighten-3">Reports</p>
              </v-list-item-content>
            </v-list-item>
          </template>
          <span>
            <p class="mb-0 mt-2">Reports is only available with the Lee Lee Student Edition purchase.</p>
            <p class="mb-0 mt-2">Available in Reports:</p>
            <ul>
              <li>Tracking student learning and errors</li>
              <li>Assesment results</li>
            </ul>
          </span>
        </v-tooltip>
        <v-list-item to="/schoolTeacher/resources">
          <v-list-item-icon class="mr-4">
              <v-icon size="30">mdi-file-cog</v-icon>
            </v-list-item-icon>

          <v-list-item-content>
            <p class="subtitle-1">Resources</p>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list dense>
        <v-list-item to="/schoolTeacher/settings">
          <v-list-item-icon class="mr-4">
              <v-icon size="30">mdi-cog</v-icon>
            </v-list-item-icon>

          <v-list-item-content>
            <p class="subtitle-1">Settings</p>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/schoolTeacher/help" v-if="isClever">
          <v-list-item-icon class="mr-4">
              <v-icon size="30">mdi-help-circle</v-icon>
            </v-list-item-icon>
          <v-list-item-content>
            <p class="subtitle-1">Help Center</p>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout">
            <v-list-item-action class="mr-4">
              <v-icon size="30">mdi-logout-variant</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <p class="subtitle-1">Logout</p>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main app fluid style="height: 100vh;" >
        <v-snackbar top v-model="snackbar" timeout="4000" color="blue-grey">
            se actualizo correctamente
            <template v-slot:action="{ attrs }">
            <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
        <router-view/>
    </v-main>
  </div>
</template>
<script>
import { auth, db } from '../plugins/firebase'
export default {
  data: () => ({
    drawer: true,
    group: null,
    dialogSettings: false,
    loadingPassword: false,
    password: '',
    snackbar: false,
    textUpdatePassword: '',
    ButtonBakc: false,
    mini: false,
    isClever: false,
    IsRegister: false,
    enableMove: true,    
    timeout: '',    
    TooltipMenuClassroom: false,
    TooltipMenuReports: false,
    idle: false,
    timeBeforeIdle: null,
    isLoggingOut: false,
    hasClassrooms: null,
    teacherExists: true
  }),
  methods: {
    async logout () {
      this.isLoggingOut = true;           
      await auth().signOut();
      this.saveTimeOnline(); 
      localStorage.removeItem('email');
      localStorage.removeItem('uid');
      localStorage.removeItem('role');
      localStorage.removeItem('token');
      localStorage.removeItem('register');
      /*localStorage.removeItem('initialTime');
      localStorage.removeItem('savedTime');
      localStorage.removeItem('activeWeb');*/
      setTimeout(function(){
        location.href = "/login";
      }, 1000);      
    },
    settings () {
      this.dialogSettings = true;
    },
    goRoute (page) {
      // console.log('asd')
      this.$router.push({name: page});
    },
    OpenTe () {
      if (this.$route.name != "activitiesList") {
        location.href = "/schoolTeacher/activitieslist";
      }else{
        this.drawer =false;
      }
    },
    handleBeforeUnload(event) {
      if (!this.isLoggingOut) {
        // Personaliza el mensaje de advertencia que se mostrará al usuario
        const confirmationMessage = '¿Seguro que quieres abandonar la página? Los cambios no guardados se perderán.';
      
        // Establece el mensaje en el evento
        event.returnValue = confirmationMessage;
        
        // Algunos navegadores pueden no mostrar el mensaje personalizado
        return confirmationMessage;
      }
    },
    async saveTimeOnline(){console.log("Desde saveTimeOnline: "+this.timeBeforeIdle);
      this.enableMove = false;
      clearTimeout(this.timeout);

      const uidTeacher=this.$store.state.user.uid;
      //const teacherData=await db.collection("SchoolTeacher").doc(uidTeacher).get();
      //if (!teacherData.exists) {
      if (!this.teacherExists) {
        localStorage.removeItem('initialTime');
        localStorage.removeItem('savedTime');
        localStorage.removeItem('activeWeb');
        return;
      }
      const initialTime=localStorage.getItem('initialTime');
      let endTime = Date.now();
      // console.log("ULTIMO TIME TOMADO---> "+endTime);
      if (this.timeBeforeIdle!=null && (endTime-this.timeBeforeIdle)>300000)
        endTime = this.timeBeforeIdle;
      
      // console.log("GUARDANDO TIME...");
      // console.log("initialTime-> "+initialTime, "endTime-> "+endTime);

      const onlineTime = Math.floor((endTime - initialTime) / 1000);
      // console.log("onlineTime-> "+onlineTime);
      // console.log("this.$store.state.user.uid-> "+uidTeacher);
      const savedTime=parseInt(localStorage.getItem('savedTime'));
      //db.collection("SchoolTeacher").doc(this.$store.state.user.uid).update({OnlineTimeWeb: onlineTime});
      try {
        //await db.collection("SchoolTeacher").doc(uidTeacher).update({OnlineTimeWeb: onlineTime});
        //await db.collection("SchoolTeacher").doc(uidTeacher).set({OnlineTimeWeb: onlineTime}, {merge: true});
        const xmlhttp=new XMLHttpRequest();
        xmlhttp.open("POST","https://us-central1-leeleeadmin2022.cloudfunctions.net/sendTeacherTimeWeb", true);
        xmlhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xmlhttp.send('onlineTime='+(onlineTime+savedTime)+'&id='+uidTeacher);
        this.$store.commit('setActiveWeb', false);
        this.timeBeforeIdle=null;    
      } catch (error) {
        console.error("Error al guardar el tiempo en línea:", error);
      }
    },
    idleTimeExit(){
      let me=this;     
      this.timeout = setTimeout(function(){
        console.log("se acabo el tiempo de espera, procedemos a guardar el tiempo en web.");
        me.saveTimeOnline();
        me.idle=true;
      },300000);//despues de 5 min guardamos los datos
    },
    async getPlusTime(){
      await db.collection("SchoolTeacher").doc(this.$store.state.user.uid).onSnapshot((teacherData) => {
        if (teacherData.exists) {
          let timeS=0;
          if (Object.prototype.hasOwnProperty.call(teacherData.data(), 'OnlineTimeWeb')){
            if (!isNaN(teacherData.data().OnlineTimeWeb) && teacherData.data().OnlineTimeWeb>0){
              timeS=teacherData.data().OnlineTimeWeb;
            }
          }
          if (this.IsRegister)
            this.hasClassrooms=Object.prototype.hasOwnProperty.call(teacherData.data(), 'HasClassrooms')?teacherData.data().HasClassrooms:false;
          else
            this.hasClassrooms=Object.prototype.hasOwnProperty.call(teacherData.data(), 'HasClassrooms')?teacherData.data().HasClassrooms:true;
          this.$store.commit('setSavedTime', timeS);console.log('getPlusTime--->'+this.hasClassrooms);
        }else{
          this.teacherExists=false;
          console.log('El profesor ha sido eliminado.');
        }
      }, (error) => {
        console.log(error);
      });  
    },
    /*async getPlusTime(){
      const teacherData=await db.collection("SchoolTeacher").doc(this.$store.state.user.uid).get();
      let timeS=0;
      if (Object.prototype.hasOwnProperty.call(teacherData.data(), 'OnlineTimeWeb')){
        if (!isNaN(teacherData.data().OnlineTimeWeb) && teacherData.data().OnlineTimeWeb>0){
          timeS=teacherData.data().OnlineTimeWeb;
        }
      }
      this.hasClassrooms=Object.prototype.hasOwnProperty.call(teacherData.data(), 'HasClassrooms')?teacherData.data().HasClassrooms:true;
      this.$store.commit('setSavedTime', timeS);
    },*/
    async startTimer(){      
      // console.log("Desde startTImer: "+this.timeBeforeIdle);
      const activeW=localStorage.getItem('activeWeb');
      // console.log("Estadooo-->>",activeW);
      if (activeW==null || activeW=='false'){
        console.log("***********************VOlVEMOS a COGER EL TIEMPO**********************");
        await this.getPlusTime();
        
        const initialTime = Date.now();
        this.$store.commit('setInitialTime', initialTime);
        this.$store.commit('setActiveWeb', true);      
      }
    },
    browserStatus(){
      //const endTime = Date.now();
      let myDate=new Date();
      let hours = myDate.getHours();
      let minutes = myDate.getMinutes();
      let seconds = myDate.getSeconds();
      if (hours < 10) hours = 0 + hours;
      if (minutes < 10) minutes = "0" + minutes;
      if (seconds < 10) seconds = "0" + seconds;
      // console.log(document.visibilityState);
      // console.log("No me ves desde: "+hours+ ":" +minutes+ ":" +seconds);
      if (document.visibilityState=='visible')
        this.timeBeforeIdle = null;
    },
    timeWithoutTouching(){
      this.timeBeforeIdle = Date.now();
      // console.log("Time Before Idle: "+this.timeBeforeIdle);
    },
    touching(){
      this.timeBeforeIdle = null;
      // console.log("Ya que volviste borramos.");
    },
    mouseMove() {
      if (!this.idle){
        //if (!me.enableMove) return;
        clearTimeout(this.timeout);
        // console.log("mouse move");
        this.idleTimeExit();
      }else{//Si la web estuvo inactiva, volvemos a contar el tiempo
        this.startTimer();
        this.idle=!this.idle;
      }
    }
    // ChangePassword () {
    //   if (this.password == '') {
    //     this.textUpdatePassword = 'incorrect password';
    //     setTimeout(() => (this.textUpdatePassword = ''), 3000);
    //     return;
    //   }
    //   this.loadingPassword=true;
    //   var user = auth().currentUser;
    //   // console.log(auth().currentUser)
    //   let aux=this;
    //     user.updatePassword(this.password).then(function() {          
    //       aux.dialogSettings = false;
    //       aux.loadingPassword=false;
    //       aux.snackbar =true;
    //     }).catch(function(error) {
    //       console.log(error)
    //       aux.loadingPassword=false;
    //       aux.textUpdatePassword = error.message;
    //       setTimeout(() => (aux.textUpdatePassword = ''), 3000);
    //     });
    // },
    // async Opentools () {
    //   const token = await auth().currentUser.getIdToken();
    //   console.log(token);
    //   window.location.href = "leelee://game?token="+token;
    //   console.log('asd')
    // }
  },
  created() {    
    window.addEventListener('mouseout', this.timeWithoutTouching);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
    window.addEventListener('beforeunload', this.saveTimeOnline);
    window.addEventListener('blur', this.timeWithoutTouching);
    window.addEventListener('focus', this.touching);
    window.addEventListener('visibilitychange', this.browserStatus);
  },
  async mounted() {
    // console.log(this.$store.state.user.uid);
    // console.log("QUE SERA ESTO----->"+localStorage.getItem('activeWeb'));
    
    await this.startTimer();
    this.idleTimeExit();
    this.timeWithoutTouching();

    if (this.$store.state.user.role != "schoolTeacher") {
      this.logout();
    }
    
    this.IsRegister = localStorage.getItem('register');
    db.collection('TempTokensClever').doc(this.$store.state.user.uid).get().then((doc) => {
        if(doc.exists){
          this.isClever=true;
        }
    });    
    
    let me = this;     
    document.onmousemove = me.mouseMove;

    //Para dispositivos moviles o touch
    /*document.ontouchmove = function () {
      if (!me.idle){
        //if (!me.enableMove) return;
        clearTimeout(me.timeout);
        console.log("presiono la pantalla");
        me.idleTimeExit();
      }else{//Si la web estuvo inactiva, volvemos a contar el tiempo
        me.startTimer();
        me.idle=!me.idle;
      }
    }*/
  },
  beforeDestroy() {
    this.enableMove = false;
    clearTimeout(this.timeout);
    window.removeEventListener('beforeunload', this.handleBeforeUnload);    
  }
}
</script>
<style>
  .icono-lateral img{
    width: 25px;
    height: 25px;
    margin-right: 30px;
  }
  .centrar-imagen {
    margin-left: auto;
    margin-right: auto;
  }
  .titulo-card{
    font-size: 1.7em;
    font-weight: 800;
    color: #01a2a5;
  }
</style>
